module.exports = __webpack_public_path__ + "static/evergreen-table-sorting-b296f951dee9d67c4c863594f10763bf.png";